import { set } from 'cerebral/operators'

export default [set('users.searchOptions.isOpen', true)]



// WEBPACK FOOTER //
// ./src/modules/user/chains/openSearchOption.js